export type IconName =
  | 'today' | 'rescue' | 'progress' | 'plans' | 'settings'
  | 'edit' | 'arrow-right' | 'spark' | 'check' | 'plus' | 'shield' | 'backup';

const PATHS: Record<IconName, string> = {
  today:    'M12 2 4 6v6c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V6z',
  rescue:   'M12 3l2.6 6.1L21 10l-5 4.4L17.4 21 12 17.8 6.6 21 8 14.4 3 10l6.4-.9z',
  progress: 'M3 17l5-5 4 4 8-9M14 7h6v6',
  plans:    'M4 6h16M4 12h16M4 18h10',
  settings: 'M12 8a4 4 0 100 8 4 4 0 000-8zM3 12h2M19 12h2M12 3v2M12 19v2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4L7 17M17 7l1.4-1.4',
  edit:     'M4 17.6V20h2.4l9-9-2.4-2.4-9 9zM14.7 6.3l2.4-2.4 2 2-2.4 2.4z',
  'arrow-right': 'M5 12h14M13 6l6 6-6 6',
  spark:    'M12 2v4M12 18v4M2 12h4M18 12h4M5 5l3 3M16 16l3 3M5 19l3-3M16 8l3-3',
  check:    'M5 12l5 5L20 7',
  plus:     'M12 5v14M5 12h14',
  shield:   'M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6z',
  backup:   'M12 3v12M7 10l5 5 5-5M5 21h14',
};

export function icon(name: IconName, opts: { class?: string; size?: number } = {}): SVGElement {
  const ns = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(ns, 'svg');
  const size = opts.size ?? 18;
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', String(size));
  svg.setAttribute('height', String(size));
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('stroke-width', '1.8');
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');
  svg.setAttribute('aria-hidden', 'true');
  if (opts.class) svg.setAttribute('class', opts.class);
  const path = document.createElementNS(ns, 'path');
  path.setAttribute('d', PATHS[name]);
  svg.appendChild(path);
  return svg;
}
